import { isListingFromMove } from '@/domain/listings/isListingFromMove'
import { type GenericFullListing } from '@/features/listing/types/listings'
import { isDealerListing } from '@/features/listing/utils/isDealerListing'

export const isSM360Listing = (listing: GenericFullListing): boolean =>
  isDealerListing(listing.attributes) && isListingFromMove(listing.id)
